import * as React from 'react';
import classNames from 'classnames';
import { flatten } from 'lodash';
import InlineScroll from 'src/components/InlineScroll/InlineScroll';
import { AppStateComponent } from 'src/AppState/AppState';

import {
    AccountTab,
    NonActiveAccountTab,
    TabsNavigationClose,
    CustomerInnerTab,
    CustomerInnerTabLink,
    LeftMenuItemTab,
    ListItemLink,
    AuditTabLink,
    AuditTab,
    AuditTabClose,
    ArrowIconWrapper,
    NavigationLinksWrapper,
    TabsContent,
    TabPanel,
} from 'src/components/Tabs/Tabs.style';

interface TabsPropsType {
    active?: string | number | boolean | null;
    allowNoActive?: boolean;
    allowClose?: boolean;
    allowSideScroll?: boolean;
    className?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    style?: any;
    children?: React.ReactNode;
    onChange?: (key: number | string | null) => void;
    onClose?: (key: number | null) => void;
    tabsPlacement?: string;
    keepMounted?: boolean;
}

type ActiveType = { active: TabsPropsType['active'] };

class Tabs extends AppStateComponent<TabsPropsType, ActiveType> {
    public constructor(props: TabsPropsType) {
        super(props);

        this.state = this.getState(props);
    }

    public UNSAFE_componentWillReceiveProps(props: TabsPropsType): void {
        this.setState(this.getState(props));
    }

    public getState(props: TabsPropsType): ActiveType {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/no-unnecessary-condition
        if (!props.active && !this.props.active && this.state && this.state.active) {
            return {
                active: this.state.active,
            };
        }

        return {
            //@ts-expect-error
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            active: props.active || (!props.allowNoActive && props.children[0] && props.children[0].key),
        };
    }

    public switchTab(key: number | string | null) {
        return (e: React.SyntheticEvent): void => {
            e.preventDefault();

            if (this.props.allowNoActive === true && key == this.state.active) {
                key = null;
            }

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (this.props.onChange) {
                this.props.onChange(key);
            }

            this.setState(
                {
                    active: key,
                },
                () => {
                    this.appState.customerTabState.getTabName(key ?? '');
                }
            );
        };
    }

    public closeTab(key: number | null) {
        return (e: React.SyntheticEvent): void => {
            e.preventDefault();
            e.stopPropagation();

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (this.props.onClose) {
                this.props.onClose(key);
            }
        };
    }
    public render(): JSX.Element {
        const { children, className, allowClose, allowSideScroll, style, tabsPlacement, keepMounted } = this.props;
        const { active } = this.state;

        let currentTabContent;
        const allChildren: Array<{ key: string; content: React.ReactNode }> = [];
        //@ts-expect-error
        const links = flatten([].concat(children))
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            .filter((item) => item !== null)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((item: any) => {
                // TODO: Very temporary solution for new design in bonus page
                const route = $appState.router.route;
                if (
                    item.key === 'anonymous' &&
                    active === false &&
                    typeof route === 'string' &&
                    route.includes('bonus-engine')
                ) {
                    return null;
                }
                const itemProps = {
                    key: item.key,
                    className: item.className,
                };

                if (item.props === undefined) {
                    // eslint-disable-next-line react/jsx-no-useless-fragment
                    return <></>;
                }

                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                if (item.props.className) {
                    itemProps.className = item.props.className;
                }

                if (active?.toString() === item.key) {
                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, prefer-template
                    itemProps.className = itemProps.className ? itemProps.className + ' active ' : 'active';
                    currentTabContent = item;
                }

                if (keepMounted === true) {
                    allChildren.push({ key: item.key, content: item });
                }

                let closeButton;
                if (allowClose === true) {
                    closeButton = (
                        <a
                            href='#'
                            className='tabs-navigation-close'
                            onClick={this.closeTab(item.key)}
                            data-test='tabs-navigation-close'
                        >
                            &times;
                        </a>
                    );
                }

                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                if (item.props.href && item.props.isAccountBlocked) {
                    return (
                        // eslint-disable-next-line react/jsx-props-no-spreading, react/jsx-key
                        <AccountTab {...itemProps}>
                            <NonActiveAccountTab
                                isActive={item.props.id === this.props.active}
                                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                href={item.props.href || '#'}
                                onClick={this.switchTab(item.key)}
                            >
                                {item.props.label}
                            </NonActiveAccountTab>
                            <TabsNavigationClose
                                isActive={item.props.id === this.props.active}
                                href='#'
                                onClick={this.closeTab(item.key)}
                                data-test='tabs-navigation-close'
                            >
                                {' '}
                                &times;
                            </TabsNavigationClose>
                        </AccountTab>
                    );
                }

                if (tabsPlacement === 'customer-inner-tabs') {
                    return (
                        <CustomerInnerTab
                            key={item.key}
                            isActive={active === item.key}
                        >
                            <CustomerInnerTabLink
                                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                href={item.props.href || '#'}
                                onClick={this.switchTab(item.key)}
                            >
                                {item.props.label}
                            </CustomerInnerTabLink>
                        </CustomerInnerTab>
                    );
                }

                if (tabsPlacement === 'left-vertical-menu') {
                    const route = item.props.href ?? '#';

                    return (
                        <LeftMenuItemTab
                            //@ts-expect-error
                            key={item.key}
                            {...itemProps}
                        >
                            <ListItemLink
                                isActive={active === item.key}
                                route={route}
                                onClick={this.switchTab(item.key)}
                            >
                                {item.props.label}
                                <ArrowIconWrapper
                                    isActive={active === item.key}
                                    position='right'
                                />
                            </ListItemLink>
                            {closeButton}
                        </LeftMenuItemTab>
                    );
                }

                if (tabsPlacement === 'audit-tabs') {
                    return (
                        <AuditTab
                            isActive={active === item.key}
                            //@ts-expect-error
                            key={item.key}
                            {...itemProps}
                        >
                            <AuditTabLink
                                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                href={item.props.href || '#'}
                                onClick={this.switchTab(item.key)}
                            >
                                {item.props.label}
                            </AuditTabLink>
                            <AuditTabClose
                                href='#'
                                className='tabs-navigation-close'
                                onClick={this.closeTab(item.key)}
                            >
                                &times;
                            </AuditTabClose>
                        </AuditTab>
                    );
                }

                return (
                    <li
                        //@ts-expect-error
                        key={item.key}
                        {...itemProps}
                    >
                        <a
                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            href={item.props.href || '#'}
                            onClick={this.switchTab(item.key)}
                            data-test={`${item.key}-link`}
                        >
                            {item.props.label}
                        </a>
                        {closeButton}
                    </li>
                );
            });

        let tabsNavigation = <NavigationLinksWrapper className='tabs-navigation'>{links}</NavigationLinksWrapper>;

        if (allowSideScroll === true) {
            tabsNavigation = <InlineScroll>{tabsNavigation}</InlineScroll>;
        }
        return (
            <div
                className={classNames([className, 'tabs', { tabs__opened: active }])}
                style={style}
            >
                {tabsNavigation}
                <TabsContent className='tabs-content'>
                    {keepMounted === true
                        ? allChildren.map(({ key, content }) => (
                              <TabPanel
                                  key={key}
                                  isActive={active?.toString() === key}
                              >
                                  {content}
                              </TabPanel>
                          ))
                        : currentTabContent}
                </TabsContent>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default Tabs;
